import { useMemo } from "react";
import { Grid } from "@mantine/core";
import StackedBarChart from "./stackedBarChart";
import { buildAssetsInfoFromCashflow } from "./ASSET_CONFIG";

const AssetCost = ({ isAssetChecked, resultSimulationData, isAssetTable, enabledAssets, onEnabledAssetsChange }) => {
  const stackedData = useMemo(
    () => buildAssetsInfoFromCashflow(resultSimulationData?.assetCashflow),
    [resultSimulationData?.assetCashflow]
  );

  return (
    <Grid gutter="md" className="mt-2 mb-2" justify="space-between">
      <Grid.Col span={3} style={{ minWidth: "100%", height: "100%" }}>
        <StackedBarChart
          stackedData={stackedData}
          isAssetChecked={isAssetChecked}C
          isAssetTable={isAssetTable}
          enabledAssets={enabledAssets}
          onEnabledAssetsChange={onEnabledAssetsChange}
        />
      </Grid.Col>
    </Grid>
  );
};

export default AssetCost;
